export default __webpack_public_path__ + "static/media/googleLogo.6bc7d493.png";